import React from 'react';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import FigmaBadge from '../Elements/FigmaBadge';

export default class CommissionRateItem {
  constructor(item) {
    if (item === undefined) {
      this.CommissionRateId = null;
      this.UserId = null;
      this.CommissionYearPeriod = null;
      this.Rate = null;
      this.CurrencyId = null;
      this.StartedOn = new Date();
      return;
    }
    this.CommissionRateId = item.commissionRateId;
    this.UserId = item.userId;
    this.CommissionYearPeriod = item.commissionYearPeriod;
    this.Rate = item.rate;
    this.CurrencyId = item.currencyId;
    this.CurrencyCode = item.currencyCode;
    this.StartedOn = item.startedOn;
    this.ClosedOn = item.closedOn;
    this.CreatedOn = item.createdOn;
    this.IsActive = item.isActive;
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static DateFields = ['ClosedOn', 'StartedOn', 'CreatedOn'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Commission Rate ID', orderById: 'CommissionRateId', data: 'CommissionRateId', minWidth: 20 },
      { label: 'Year', orderById: 'Year', data: (item) => `Year ${item.CommissionYearPeriod}` },
      { label: 'Rate', orderById: 'Rate', data: (item) => `${item.Rate}%` },
      { label: 'Currency', orderById: 'CurrencyCode', data: 'CurrencyCode' },
      { label: 'Start Date', orderById: 'StartedOn', data: 'StartedOn' },
      { label: 'Close Date', orderById: 'ClosedOn', data: 'ClosedOn' },
      { label: 'Created On', orderById: 'CreatedOn', data: 'CreatedOn' },
      { label: 'Is Active?', orderById: 'IsActive', data: (item) => <FigmaBadge Active={item.IsActive} /> },
      {
        label: ' ',
        orderById: '',
        data: CommissionRateItem.getEditUserFieldContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getEditUserFieldContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            onClick: () => CommissionRateItem.editFunction(item.UserId, item),
            text: 'Edit',
            tooltipText: 'Edit Commission Rate',
            disabled: item.ClosedOn,
          },
          {
            iconName: 'fa-solid fa-lock',
            onClick: () => CommissionRateItem.closeFunction(item.UserId, item),
            text: 'Close',
            tooltipText: 'Close Commission Rate',
            disabled: item.ClosedOn,
          },
        ]}
      />
    );
  }

  static editFunction = (id, user) => {
    alert('Empty Function');
  };

  static closeFunction = (id, user) => {
    alert('Empty Function');
  };
}
